
const SystemEntryCallbackType="()=>void";
const SystemEntryFallbackType="(error:Error)=>void";
export const SystemEntryCallback={
    name:"callback",
    type:SystemEntryCallbackType,
},SystemEntryFallback={
    name:"fallback",
    type:SystemEntryFallbackType,
}

export const SystemEntryPropsParam={
    name:"props",type:"object",
    props:[
        {name:"location",type:"string"},
        {name:"name",type:"string"},
    ],
};


export const SystemEntryProperties=[
    ...["name","fullpath","location"].map(name=>({name,type:"string"})),
    {
        name:"copyTo",
        type:`(path:string,callback:function,fallback:function):Promise<undefined>`,
        props:[
            SystemEntryCallback,
            SystemEntryFallback,
            {
                name:"path",type:"string",
                description:"path of the file new location",
            },
        ],
    },
    {
        name:"moveTo",
        type:`(path:string,callback:function,fallback:function):Promise<undefined>`,
        description:"If the file is located in a read-only location, it behaves as the copyTo method",
        props:[
            SystemEntryCallback,
            SystemEntryFallback,
            {
                name:"path",type:"string",
                description:"path of the file new location",
            },
        ],
    },
    {
        name:"rename",
        type:`(newName:string,callback:function,fallback:function):Promise<undefined>`,
        description:"Renames the current entry@Does not change the file extension",
        props:[
            SystemEntryCallback,
            SystemEntryFallback,
            {
                name:"newName",type:"string",
                description:"entry new basename (without extension)",
            }
        ],
    },
    {
        name:"delete",
        type:`(callback:function,fallback:function):Promise<undefined>`,
        description:"Deletes the entry",
        props:[
            SystemEntryCallback,
            SystemEntryFallback,
        ]
    },
]
